import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'lib-common-rejected',
  templateUrl: './common-rejected.component.html',
  styleUrls: ['./common-rejected.component.css']
})
export class CommonRejectedComponent implements OnInit {
  @Input() headerstmt ;
  @Input() urlWebFilingId ;
  errormsg = ""
  constructor() { }

  ngOnInit(): void {
  }
return_pagemntOptions(): void {
        window.open(sessionStorage.getItem("paymentUrl"), "_self");
  }
}
